import io from "socket.io-client";

export class SocketIo {
  _io; // socket.io链接

  constructor(url, options, connectCallback, disconnectCallback) {
    options.transports = ["websocket", "polling"];
    this.buildSocket(url, options);
    this.on("connect", connectCallback);
    this.on("disconnect", disconnectCallback);
  }

  buildSocket(url, options) {
    this._io = io(url, options);
  }

  disconnect() {
    this._io.disconnect();
  }

  unReconnection() {
    console.log(this._io.io.reconnection());
    this._io.io.reconnection(false);
    console.log(this._io.io.reconnection());
  }

  emit(event, data) {
    this._io.emit(event, data);
  }

  on(event, callback) {
    this._io.on(event, callback);
  }
}
